export const useZipCodeMask = (value: string) => {
    let newValue = value.replace(/\D/g, "");
    newValue = newValue.replace(/(\d{5})(\d)/, "$1-$2");
    return newValue;
};
